import './App.css';
import Timeline from './components/Timeline';
import 'bulma/css/bulma.min.css';

function App() {
  return (
    <div className="App">
      <Timeline />
    </div>
  );
}

export default App;
